export const BC_LOGOUT = 'app/broadcastChannel/BC_LOGOUT';
